var map = {
	"./caseIH.svg": 33007,
	"./claas.svg": 8964,
	"./deutzFahr.svg": 88251,
	"./dllGroup.svg": 3397,
	"./efarmFinancing.svg": 97036,
	"./fendt.svg": 21257,
	"./johnDeere.svg": 8438,
	"./kubota.svg": 80064,
	"./masseyFerguson.svg": 95091,
	"./newHolland.svg": 72468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27809;